// extracted by mini-css-extract-plugin
module.exports = {"filterTag":"FilterTag_filterTag__uwQOG","prefix":"FilterTag_prefix__YaqVF","label":"FilterTag_label__wYqZy","icon":"FilterTag_icon__eOhF4","shimmer":"FilterTag_shimmer__wSqbR"};